import {
  useURLParamsGetter,
  useURLParamsSetter,
} from "~/hooks/useURLParamsSetter";

interface UseTariffFormModalResult {
  isOpen: boolean;
  isEditMode: boolean;
  currentId: string | null;
  closeModal: () => void;
}

/**
 * Общая обвязка модалки формы тарифа: читает `openModal`/`currentId` из URL,
 * считает `isOpen`/`isEditMode`, даёт `closeModal`. Переиспользуется модалками
 * Base/Additional/(Personal).
 */
export const useTariffFormModal = (
  createKey: string,
  editKey: string,
): UseTariffFormModalResult => {
  const { openModal, currentId } = useURLParamsGetter<{
    openModal?: string;
    currentId?: string;
  }>();
  const setParams = useURLParamsSetter();

  const isEditMode = openModal === editKey;
  const isOpen = openModal === createKey || isEditMode;

  const closeModal = () =>
    setParams({ openModal: undefined, currentId: undefined });

  return {
    isOpen,
    isEditMode,
    currentId: currentId ?? null,
    closeModal,
  };
};
